<sd-6-17-1-dialog
  #dialog
  [headline]="headline | transloco">
  <div class="delete-filter-template-dialog">
    <p class="delete-message">{{ message | transloco }}</p>

    <p class="template-name">{{ nameLabel | transloco }}: {{ templateName() }}</p>

    <div class="dialog-actions">
      <sd-6-17-1-button
        variant="tertiary"
        type="button"
        (click)="cancel()">
        {{ cancelLabel | transloco }}
      </sd-6-17-1-button>
      <sd-6-17-1-button
        variant="primary"
        type="button"
        (click)="confirm()">
        {{ confirmLabel | transloco }}
      </sd-6-17-1-button>
    </div>
  </div>
</sd-6-17-1-dialog>

